import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  { path: '', redirectTo: '/cookbook', pathMatch: 'full' }, // redirect to `cookbook`
  {
    path: 'cookbook',
    loadComponent: () =>
      import('./components/recipes.component').then((m) => m.RecipesComponent),
  },
  { path: '**', redirectTo: '/cookbook' },
];
